<template>
  <div class="row">
    <div class="col-md-12" v-if="!loading">
      <h1 class="h3 mb-3 text-gray-800">{{ title }}</h1>
    </div>
    <load v-if="loading" :message="message_load" />
    <div v-else class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <header-familia
            :item="item"
            @show-exclusao="$bvModal.show('modal-familia-excluida')"
            @update="submit()"
          />
        </div>
      </div>
      <!--Tabela-->
      <div class="row d-flex align-items-stretch" v-if="item">
        <div class="col-md-3 mb-sm-3 mb-md-0">
          <b-button
            variant="success"
            block
            size="lg"
            squared
            @click="setServicos"
            v-if="
              tipo_menu == 'dados' //&&
              //item.estado_cadastral_id != 4 &&
              //item.estado_cadastral_id != 5
            "
          >
            <i class="mdi mdi-database-cog-outline mdi-18px"></i>
            Serviços/Intervenções
          </b-button>

          <MenuInformacao
            :menu="menuInformacao"
            :pageAtual="page"
            :estadoCadastral="item.estado_cadastral_id"
            @excluir="excluir"
          />
        </div>
        <div class="col-md-9">
          <ContentInformacao
            v-if="tipo_menu == 'dados'"
            :localidades="localidades"
            :page="page"
            :item="item"
            @submit="submit"
            @excluir="excluir"
            @atualizar="getFamilia"
          />
        </div>
      </div>
    </div>
    <excluir-familia
      :item="item"
      @reload="getFamilia"
      @cancelado="item.estado_cadastral_id = item.estado_cadastral_id_default"
    />
    <ModalFamiliaExcluida :item="item" />
  </div>
</template>

<script>
import MenuInformacao from "./includes/MenuInformacao";
import ContentInformacao from "./includes/ContentInformacao";
import ModalFamiliaExcluida from "./includes/ModalFamiliaExcluida";

export default {
  name: "Edit",
  components: {
    MenuInformacao,
    ContentInformacao,
    ModalFamiliaExcluida,
  },
  data() {
    return {
      loading: true,
      page: "identificacao",
      id: null,
      item: null,
      localidades: [],
      tipo_menu: "dados",
      title: "Prontuário Familiar",
      message_load: "Carregando o prontuário  da Família.",
      menuInformacao: [
        {
          tab: "identificacao",
          slug: "identificacao",
          titulo: "Identificação da Família",
        },
        {
          tab: "ingresso",
          slug: "ingresso",
          titulo: "Forma de Ingresso na Unidade",
        },
        {
          tab: "composicao",
          slug: "composicao",
          titulo: "Composição Familiar",
        },
        {
          tab: "habitacao",
          slug: "habitacao",
          titulo: "Condições Habitacionais",
        },
        {
          tab: "educacao",
          slug: "educacao",
          titulo: "Condições Educacionais",
        },
        {
          tab: "financeiro",
          slug: "financeiro",
          titulo: "Condições Financeiras",
        },
        {
          tab: "saude",
          slug: "saude",
          titulo: "Condições de Saúde",
        },
        {
          tab: "outras_caracteristicas",
          slug: "outras-caracteristicas",
          titulo: "Outras Características",
        },
        {
          tab: "convivencia",
          slug: "convivencia",
          titulo: "Convivência Familiar e Comunitária",
        },
        {
          tab: "programasServicos",
          slug: "programas-servicos",
          titulo: "Programas e Serviços",
        },
        {
          tab: "ocorrencias",
          slug: "ocorrencias",
          titulo: "Pendências e Ocorrências",
        },
        {
          tab: "anexo",
          slug: "anexo",
          titulo: "Anexo",
        },
      ],
    };
  },
  watch: {
    "$route.params.aba": {
      immediate: true,
      handler(aba) {
        this.definirAbaPelaUrl(aba);
      },
    },
  },
  mounted() {
    if (typeof this.$route.query.item === "object") {
      this.item = this.$route.query.item;
      this.loading = false;
    } else {
      this.getFamilia();
    }
  },
  methods: {
     definirAbaPelaUrl(aba) {
      const abaPadrao = this.menuInformacao[0];

      if (!aba) {
        this.page = abaPadrao.tab;
        return;
      }

      const item = this.menuInformacao.find((menu) => menu.slug === aba);

      if (!item) {
        this.page = abaPadrao.tab;

        this.$router
          .replace({
            name: "familias_edit",
            params: {
              id: this.$route.params.id,
              aba: abaPadrao.slug,
            },
          })
          .catch(this.ignorarNavigationDuplicated);

        return;
      }

      this.page = item.tab;
    },

    ignorarNavigationDuplicated(error) {
      if (error && error.name !== "NavigationDuplicated") {
        throw error;
      }
    },
    setServicos() {
      this.$router.push(`/dashboard/atendimentos/${this.item.id}`);
    },
    getFamilia() {
      this.loading = true;
      axios
        .get("api/dashboard/familias/" + this.$route.params.id)
        .then((response) => {
          this.item = response.data.data;

          if (this.item.endereco) {
            this.localidades = this.item.endereco.localidade;
          }
          this.loading = false;
        })
        .catch(() => {
          this.$router.push("/dashboard/familias");
        });
    },
    submit() {
      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();
      this.loading = true;
      this.message_load = "Atualizando as informações da familia.";
      this.item.endereco.referencia = this.item.endereco.referencia_endereco;

      let dados = {
        ...this.item,
        ...{ page: this.page },
      };

      axios
        .put("api/dashboard/familias/" + this.item.id, this.item)
        .then((response) => {
          this.item = response.data.data;

          if (this.item.mensagem != "") {
            swal.fire({
              title: "Atenção!",
              html: this.item.mensagem,
              icon: "info",
            });
          } else {
            this.$snack.success({
              button: false,
              text: "Dados atualizados corretamente",
            });
          }

          ladda.stop();
        })
        .finally(() => {
          this.item.cadastrarContato = 0;
          this.item.cadastrarEndereco = 0;
          this.item.cadastrarFinanceiro = 0;
          this.item.cadastrarSaude = 0;
          this.loading = false;
        });
    },
    excluir() {
      swal
        .fire({
          title: "Tem certeza?",
          text: "A familia não poderá ser vinculado a nenhum serviço.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, exclua!",
          cancelButtonText: "Não",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$bvModal.show("modal-excluir-familia");
          } else {
            this.item.estado_cadastral_id =
              this.item.estado_cadastral_id_default;
          }
        });
    },
  },
};
</script>
<style lang="css">
.text-link {
  text-decoration: none !important;
  cursor: pointer;
}
</style>
